import React from "react";
import styled from "styled-components";
import { PreviewInput } from "../../atoms/PreviewInput";
import { ClientDetailResponse } from "../../../core/api/requests/client/detail/types";
import { getRoleDisplayName } from "../../../utils/roleMapping";

type Props = {
    client: ClientDetailResponse;
};

export const DetailClientForm: React.FC<Props> = ({ client }) => {
    // Helper function to format date in a user-friendly way
    const formatDate = (dateString: string | null | undefined): string => {
        if (!dateString) return "N/A";

        try {
            // Handle the specific API format "DD-MM-YYYY HH:mm:ss"
            if (typeof dateString === 'string' && dateString.includes('-') && dateString.includes(':')) {
                const [datePart] = dateString.split(' ');
                const [day, month, year] = datePart.split('-');
                const monthNames = [
                    'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'
                ];
                return `${day} ${monthNames[parseInt(month) - 1]} ${year}`;
            }

            // Fallback to standard Date parsing
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return "Invalid Date";
            }
            const day = date.getDate();
            const month = date.toLocaleDateString('en-US', { month: 'long' });
            const year = date.getFullYear();

            return `${day} ${month} ${year}`;
        } catch (error) {
            console.error('Error formatting date:', error);
            return "Invalid Date";
        }
    };

    return (
        <>
            <StyledFormGrid>
                <PreviewInput
                    label="Inquiry Number"
                    name="inquiry_number"
                    value={client.inquiry_number}
                    fullWidth
                />
                <PreviewInput
                    label="Inquiry Type"
                    name="inquiry_type"
                    value={client.inquiry_type || "N/A"}
                    fullWidth
                />
                <PreviewInput
                    label="First Name"
                    name="first_name"
                    value={client.first_name || "N/A"}
                    fullWidth
                />
                <PreviewInput
                    label="Last Name"
                    name="last_name"
                    value={client.last_name || "N/A"}
                    fullWidth
                />
                <PreviewInput
                    label="Email"
                    name="email_address"
                    value={client.email_address || "N/A"}
                    fullWidth
                />
                <PreviewInput
                    label="Phone Number"
                    name="phone_number"
                    value={client.phone_number || "N/A"}
                    fullWidth
                />
                <PreviewInput
                    label="Role"
                    name="role"
                    value={client.role ? getRoleDisplayName(client.role) : "N/A"}
                    fullWidth
                />
                <PreviewInput
                    label="Description"
                    name="description"
                    value={client.description || "N/A"}
                    fullWidth
                />
                <PreviewInput
                    label="Read Status"
                    name="read"
                    value={client.read ? "Yes" : "No"}
                    fullWidth
                />
                <PreviewInput
                    label="Created At"
                    name="created_at"
                    value={formatDate(client.created_at)}
                    fullWidth
                />
            </StyledFormGrid>
        </>
    );
};

const StyledFormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`; 